import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlanService {
  readonly rootURL = environment.apiurl+"plan/";

constructor(private http: HttpClient) { }

getPlans():any {
  return this.http.get(this.rootURL+`getall`).toPromise();
}

}
